import { render } from "./AdDocListNavCallToAction.vue?vue&type=template&id=7b162944&ts=true"
import script from "./AdDocListNavCallToAction.vue?vue&type=script&lang=ts"
export * from "./AdDocListNavCallToAction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__